<template>
  <div class="app-container">
    <navigation title="文章详情"></navigation>
    <div class="main">
      <div class="message">
        <div class="message-title">{{ project.title }}</div>
        <p class="message-title-sub" v-if="project.subTitle">{{ project.subTitle }}</p>
        <div v-html="project.descHtml"></div>
        <div class="cataline">
          <div class="cricle" @click="showCatalog">
            <span class="cata cata-list">目录</span>
          </div>
        </div>
        <div class="collect-share">
          <div class="collect">
            <collect v-if="project" :resource="resource"></collect>
          </div>
        </div>
        <page-share :show="showShare" @show='getShow' :title="resource.module"></page-share>
      </div>
    </div>
    <div class="change-page">
      <span class="previous" @click="getPrevious">上一章</span>
      <span class="next" @click="getNext">下一章</span>
    </div>
    <version></version>
    <van-overlay :show="show" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="prompt">
          <div class="prompt-content">
            <div class="prompt-title">
              目录
              <van-icon name="close" @click="closePrompt" class="close-img"/>
            </div>
            <div class="prompt-message">
              <tree-menu v-if="projectDirectory.length>0" :subsetList='projectDirectory' :current="current" @change="changeCurrent"></tree-menu>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup, Swipe, SwipeItem, Toast } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import pageShare from '../../components/pageShare'
import collect from '../../components/collect'
import treeMenu from '../../components/treeMenu'


Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Swipe).use(SwipeItem).use(Toast)

var playImg = document.getElementsByClassName('audio-play')
var pauseImg = document.getElementsByClassName('audio-pause')
var timeBar = document.getElementsByClassName('timeBar')
var timeStart = document.getElementsByClassName('time-start')
var timeEnd = document.getElementsByClassName('time-end')

var audioArr = {
  currentTime: '00:00',
  duration: ''
}
export default {
  name: 'articleChildDetails',
  components: {navigation, version, pageShare, collect, treeMenu },
  data () {
    return {
      projectId: this.$route.query.id,
      project: '',
      projectDirectory: '',
      showShare: false,
      resource: {
        title: '',
        module: '专题展览',
        resourceId: this.$route.query.id
      },
      show: false,
      baseUrl: process.env.API_ROOT,
      viewClick:0,
      current:'',
      parentId:this.$route.query.parentId
    }
  },
  created () {
    // 详情
    this.getDetail()
    // 目录
    this.getDirectory()
  },
  mounted () {
    // 目录点击事件绑定
    // bus.$on('currentGoDirectory', this.goDirectory)
    this.$nextTick(function() {
      window.fillTime = this.fillTime
      window.transTime = this.transTime
      window.updateProgress = this.updateProgress
      window.audioEnded = this.audioEnded
      window.play = this.play
      window.pause = this.pause
      window.videoPlay = this.videoPlay
    })
  },
  watch:{
    $route(){
      this.projectId = this.$route.query.id
    },
    projectId(){
      this.getDetail ()
    }
  },
  methods: {
    // 上一章
    getPrevious () {
      Toast.loading({
        message: '加载中...'
      });
      request('get', '/nlc-web/api/special/previous', {}, this.projectId).then(res => {
        console.log('上一章', res)
        if(res.data===''){
          Toast.clear()
          Toast('已经是第一章')
        } else {
          if(res.data.descHtml){
            res.data.descHtml = this.test(res.data.descHtml)
          }
          this.current = res.data.id
          this.projectId = res.data.id
          this.project = res.data
          this.resource.title = res.data.title
          Toast.clear()
          window.scrollTo(0,0);
        }
      })
    },
    // 下一章
    getNext () {
      Toast.loading({
        message: '加载中...'
      });
      request('get', '/nlc-web/api/special/next', {}, this.projectId).then(res => {
        console.log('下一章', res)
        if(res.data===''){
          Toast.clear()
          Toast('已经是最后一章')
        } else {
          if(res.data.descHtml){
            res.data.descHtml = this.test(res.data.descHtml)
          }
          this.current = res.data.id
          this.projectId = res.data.id
          this.project = res.data
          this.resource.title = res.data.title
          Toast.clear()
          window.scrollTo(0,0);
        }
      })
    },
    changeCurrent (id) {
      this.current = id
      this.goDirectory(id)
    },
    videoPlay () {
      let audio = document.getElementById('audio')
      if(audio.play){
        pauseImg[0].style.display='none'
        playImg[0].style.display='block'
        audio.pause()
      }
    },
    // 获取专题详情
    specialInfo(id) {
      request('get', '/nlc-web/api/special', {}, id).then(res => {
        console.log('详情', res)
        if(res.data.descHtml){
          res.data.descHtml = this.test(res.data.descHtml)
        }
        this.project = res.data
        this.resource.title = res.data.title
        window.scrollTo(0,0);
      })
    },
    // 替换音频
    test(html) {
      var split = html.split('<audio src="')
      var newHtmlArray = [];
      split.forEach(value => {
        var audioArray = value.split('" controls="controls"></audio>')
        if (audioArray.length===1) {
          newHtmlArray.push(value)
        } else {
          newHtmlArray.push('<div class="motto-audio">' +
            '<audio ref="audio" id="audio" onloadedmetadata="fillTime()" ontimeupdate="updateProgress()" onended="audioEnded()">' +
            '<source src="'+this.baseUrl)
          newHtmlArray.push(audioArray[0])
          newHtmlArray.push('" type="audio/mp3"/></audio>' +
            '<div class="motto-left">' +
            '<img src="./static/pr-play.png" alt="" class="audio-play" onclick="play()">' +
            '<img src="./static/pr-pause.png" alt="" class="audio-pause" onclick="pause()">' +
            '</div>' +
            '<div class="motto-right">' +
            '<div class="progress-strip">' +
            '<div class="progressBar">' +
            '<div class="timeBar" style="width:0px"></div>' +
            '</div>' +
            '</div>' +
            '<div class="time">' +
            '<div class="time-start">'+this.timeStart+'</div>' +
            '<div class="time-end">'+this.timeStart+'</div></div></div></div>')
          newHtmlArray.push(audioArray[1])
        }
      })
      return newHtmlArray.join('')
    },
    getDetail () {
      this.specialInfo(this.projectId)
    },
    getDirectory () {
      request('get', '/nlc-web/api/special/cataloguesAll', {}, this.parentId).then(res => {
        console.log('目录列表', res)
        this.projectDirectory = res.data
      })
    },
    goDirectory (id) {
      this.projectId = id
      this.viewClick = 1
      this.specialInfo(id)
      this.show = false
      document.body.style.overflow = 'scroll'
    },
    share () {
      this.showShare = true
      document.body.style.overflow = 'hidden'
    },
    getShow (msg) {
      this.showShare = msg
    },
    showCatalog () {
      if (this.show === false) {
        this.show = true
        document.body.style.overflow = 'hidden'
      } else {
        this.show = false
        document.body.style.overflow = 'scroll'
      }
    },
    closePrompt () {
      this.show = false
      document.body.style.overflow = 'scroll'
    },
    // 播放
    play () {
      console.log('document.getElementsByTagName(\'video\')',document.getElementById('audio'))
      let video = document.getElementsByTagName('video')
      let audio = document.getElementById('audio')
      let promise = audio.play();
      promise.then(() => {
        for (var i=0;i<video.length;i++) {
          video[i].pause()
        }
      })
      pauseImg[0].style.display='block'
      playImg[0].style.display='none'
    },
    // 暂停
    pause () {
      pauseImg[0].style.display='none'
      playImg[0].style.display='block'
      document.getElementById('audio').pause()
    },
    // 获取音频的总时长
    fillTime () {
      let audio = document.getElementById('audio')
      audioArr.duration = this.transTime(audio.duration)
      timeStart[0].innerHTML= audioArr.currentTime
      timeEnd[0].innerHTML = audioArr.duration
    },

    // 将秒数转化成(分:秒)格式
    transTime (time) {
      let duration = parseInt(time)
      let minute = parseInt(duration / 60).toString().padStart(2, '0')
      let sec = (duration % 60).toString().padStart(2, '0')
      return `${minute}:${sec}`
    },
    // 进度条播放的事件
    updateProgress () {
      let audio = document.getElementById('audio')
      let value = Math.round((Math.floor(audio.currentTime) / Math.floor(audio.duration)) * 100, 0)
      audioArr.currentTime = transTime(audio.currentTime)
      timeStart[0].innerHTML = audioArr.currentTime
      let progressTag = timeBar[0]
      progressTag.style.width = `${value}%`
    },

    // 播放结束的处理动作
    audioEnded () {
      let audio = document.getElementById('audio')
      audio.currentTime = 0
      audio.pause()
      pauseImg[0].style.display='none'
      playImg[0].style.display='block'
    }
  },
  destroyed () {
    let audio = document.getElementById('audio')
    if (audio && audio.play) {
      audio.pause()
    }
  }
}
</script>
<style scoped>
.app-container{
  background:#ecf5fd;
  overflow-y:scroll;
  min-height: 100%;
  position: absolute;
  top: 0;
  padding-bottom:.8rem;
}
.main{
  width:6.94rem;
  margin:1.07rem .28rem 0 .28rem;
}
.message{
  width:6.38rem;
  background:#fff;
  font-size:.28rem;
  color:#444649;
  position:relative;
  line-height:.42rem;
  padding:.29rem .28rem;
  border-radius:8px;
}
.message-title{
  width:100%;
  text-align:center;
  font-family: SourceHanSerifCN-Regular;
  font-size:.36rem;
  font-weight:bold;
  word-wrap: break-word;
}
.message-title-sub{
  width:100%;
  text-align:right;
  font-family: SourceHanSerifCN-Regular;
  font-size:.28rem;
  word-wrap:break-word;
}
.list{
  width:6.58rem;
  background:#fff;
  margin:.16rem 0;
  padding:.2rem .18rem .5rem .18rem;
  font-size:.28rem;
  color:#444649;
  font-family: SourceHanSerifCN-ExtraLight;
  border-radius:8px;
}
.list h1{
  color:#444649;
  font-size:.36rem;
  padding-left:.21rem;
}
.list ul li{
  height:.73rem;
  line-height:.73rem;
  border-bottom:1px solid #B3BBC3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list ul li:last-child{
  border:0;
}
.prompt-message{
  overflow-y:scroll;
  overflow-x:hidden;
  height:4rem;
}
.prompt-message ul{
  margin-right:.2rem;
}
.prompt-message ul li{
  border-bottom:1px solid #DCE5ED;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: .28rem;
  font-family: SourceHanSerifCN-SemiBold;
}
.tree_container ul li:first-child{
  border-top:1px solid #B3BBC3;
}
.tree_container ul li:last-child{
  border:0;
}
.share{
  color:#444649;
  font-size:.24rem;
  margin-left:.22rem;
  line-height: .57rem;
}
>>>.social-share .social-share-icon{
  width:.36rem;
  height:.36rem;
  line-height:.36rem;
  font-size:.2rem;
}
>>>img{
  width:100%;
}
.collect-share{
  display:flex;
  margin-top:.24rem;
}
.wrapper{
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
}
.prompt{
  width: 5.5rem;
  height: 5rem;
  background:#fff;
  font-size:.24rem;
  color:#47494c;
  border-radius:16px;
  padding:.34rem .3rem;
}
.prompt-title{
  font-size:.36rem;
  color:#444649;
  position:relative;
  padding-bottom: .15rem;
 font-family: SourceHanSerifCN-SemiBold;
}
.close-img{
  width: .36rem;
  height: .36rem;
  position:absolute;
  right:0;
  top:.1rem;
}
.cata{
  font-family: SourceHanSerifCN-SemiBold;
  font-size:.24rem;
  font-weight: 600;
  display:inline-block;
  line-height:.3rem;
  color: #ffffff;
  text-shadow: 2px 2px 2px rgba(1, 83, 96, 0.5);
}
.cata-list{
  line-height:.6rem;
}
.cricle{
  border-radius: 8px;
  width: .52rem;
  height: .6rem;
  padding: .1rem .14rem;
  text-align: center;
  position:fixed;
  bottom:1.28rem;
  right:.49rem;
}
.cataline{
  width: 6.38rem;
  position: relative;
}
.icon-down, .icon-up{
  width: .16rem;
  height: .0924rem;
  vertical-align: middle;
}

>>>.motto-audio{
  width:5.57rem;
  height:.86rem;
  margin:.32rem .2rem 0 .7rem;
  background: url("../../assets/img/audio-bg.png") no-repeat right center;
  background-size:100%;
  position:relative;
}
>>>.motto-audio audio {
  height:0;
}
>>>.motto-left{
  width:1.59rem;
  height:1.59rem;
  background:url("../../assets/img/record-bg.png") no-repeat;
  background-size:100% 100%;
  position:absolute;
  left:-.81rem;
  top:-.2rem;
}
>>>.motto-left img{
  position: absolute;
  left: .67rem;
  top: .45rem;
  width: .3rem;
  height: .3rem;
}
>>>.motto-right{
  margin-left:.78rem;
  padding-top:.35rem
}
>>>.progress-strip{
  width:4.34rem;
}
>>>.progressBar {
  position: relative;
  width: 100%;
  height:.06rem;
  background: #fff;
  border-radius:6px;
}
>>>.timeBar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #0B83A1;
  border-radius:6px;
}
>>>.time{
  font-size:.2rem;
  color:#333;
  position:relative;
  margin-top:.05rem;
}
>>>.time-start{
  position: absolute;
  left:0;
}
>>>.time-end{
  position: absolute;
  right:.45rem;
}
>>>.audio-pause{
  display:none;
}
.collect-main{
  margin-left:0;
}
.change-page{
  width:100%;
  height:.98rem;
  border-radius: .4rem .4rem 0 0;
  box-shadow: 0px -16px 40px -12px rgba(51, 51, 54, 0.2);
  background:#fff;
  font-size:.32rem;
  line-height:.98rem;
  position:fixed;
  left:0;
  bottom:0;
  z-index:1;
  display:flex;
}
.change-page span{
  flex:1;
  text-align:center;
  display:inline-block;
}
.next{
  color:#fff;
  border-radius: .4rem .4rem 0 0;
}
</style>



// WEBPACK FOOTER //
// src/view/articleChildDetails/index.vue